import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { ShieldCheckIcon, LockIcon } from 'lucide-react';
export function CheckoutSection() {
  return <section id="checkout" className="py-16 md:py-24 px-4 bg-white relative" data-id="element-50">
      <div className="max-w-3xl mx-auto text-center" data-id="element-51">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-[#FAF3E8] p-8 md:p-12 rounded-3xl shadow-2xl border-2 border-[#C8956C]" data-id="element-52">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-[#3D2B1F] mb-6" data-id="element-53">
            Tu Transformación Comienza Hoy
          </h2>

          <p className="text-lg text-[#5A4332] mb-8 leading-relaxed" data-id="element-54">
            Hoy puedes acceder al método completo "Drenaje Brasileño en Casa"
            por una fracción de lo que cuesta una sola sesión en una clínica
            estética. Olvídate de pagar $100 dólares por masaje; aprende la
            técnica por única vez y úsala de por vida.
          </p>

          <div className="mb-8" data-id="element-55">
            <p className="text-sm text-[#5A4332] uppercase tracking-wider font-bold mb-2" data-id="element-56">
              Acceso Inmediato por Solo
            </p>
            <div className="text-6xl md:text-7xl font-heading font-bold text-[#D4654A]" data-id="element-57">
              $9.87 <span className="text-2xl text-[#5A4332]" data-id="element-58">USD</span>
            </div>
          </div>

          <Button isCheckout={true} href="https://pay.hotmart.com/H104933257N" className="w-full text-xl py-5 animate-pulse-slow shadow-[0_0_30px_rgba(200,149,108,0.5)]" data-id="element-59">
            ¡QUIERO EMPEZAR MI TRANSFORMACIÓN AHORA!
          </Button>

          <p className="mt-4 text-sm text-[#5A4332] italic" data-id="element-60">
            *Recibe tu guía digital al instante en tu correo electrónico tras la
            compra segura.
          </p>

          <div className="flex items-center justify-center gap-6 mt-8 pt-8 border-t border-[#C8956C]/20" data-id="element-61">
            <div className="flex items-center gap-2 text-[#7C9A6E]" data-id="element-62">
              <ShieldCheckIcon className="w-5 h-5" data-id="element-63" />
              <span className="text-sm font-bold" data-id="element-64">
                Garantía de Satisfacción
              </span>
            </div>
            <div className="flex items-center gap-2 text-[#5A4332]" data-id="element-65">
              <LockIcon className="w-5 h-5" data-id="element-66" />
              <span className="text-sm font-bold" data-id="element-67">Pago 100% Seguro</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}